module.exports = __webpack_public_path__ + "static/june-7-a3f1f1416e5ae1dfb3743e895e5b4c68.png";